<!--
 * @Date: 2024-05-15 09:30:33
 * @LastEditTime: 2024-05-22 13:55:43
-->
<template>
  <Schedule
    style="margin-top: 0px"
    ref="scheduleRef"
    :options="scheduleSetup"
  />
  <van-popup v-model:show="isSelectMonth" position="bottom">
    <van-datetime-picker
      v-model="currentDate"
      type="year-month"
      title="年月を選択"
      :currentDate="currentDate"
      :minDate="minDate"
      :maxDate="maxDate"
      @confirm="onGotoMonth"
      @cancel="isSelectMonth = false"
    />
  </van-popup>
  <van-dialog
    v-model:show="isEventDialog"
    theme="round-button"
    closeable
    @click.stop
    :show-cancel-button="false"
    :show-confirm-button="false"
    :title="event?.yotei_name || ''"
  >
    <template #title>
      <div
        style="
          font-size: 1.5rem;
          font-weight: bold;
          word-wrap: break-word;
          padding-top: 15px;
        "
      >
        {{ event.yotei_name }}
      </div>
    </template>
    <van-row style="padding: 20px">
      <van-col style="padding-top: 15px" span="24">
        <span style="word-break: break-all">
          備考：{{ event.memo }}
        </span>
      </van-col>
      <van-col style="padding-top: 15px" span="24">ルーム：{{ event.room_name }}</van-col>
      <van-col style="padding-top: 15px" span="24">開始時刻：{{ event.start_time }}</van-col>
      <van-col style="padding-top: 15px" span="24">終了時刻：{{ event.end_time }}</van-col>
      <van-col style="padding-top: 15px" span="24">
        <div style="display: flex; flex-wrap: wrap">
          <span>参加者：</span>
          <span v-for="({ name }, index) in event.room_doctors" :key="index">{{
            name + (index === event.room_doctors.length - 1 ? "" : "、")
          }}</span>
        </div>
      </van-col>
      <van-col v-show="showShareLink" style="padding-top: 15px;word-break: break-all; " span="24" @click="copyText(event.roomyotei_url)">
        会議リンク：{{ event.roomyotei_url }}
      </van-col>
      <van-col v-show="showShareLink" style="padding-top: 15px" span="24" @click="copyText(event.ticket)">
        チケット：{{ event.ticket }}
      </van-col>
      <van-col v-show="showShareLink" style="padding-top: 15px;" span="24">
        チケット期限：{{ event.end_time }}
      </van-col>
    </van-row>
    <van-row v-if="isEnterRoom && isNeedEnterRoom" justify="center">
      <van-col span="7">
        <van-button
          :loading="isEnterRoomLoading"
          round
          color="#3B82C4"
          size="small"
          @click="onEnterRoom(event.room_id)"
          style="width: 100%"
        >
          <template #icon>
            <img
              src="@/assets/img/tel/icon_entering.png"
              style="width: 20px; vertical-align: middle"
              alt=""
            />
          </template>
          入室する
        </van-button>
      </van-col>
    </van-row>
    <van-row
      v-else-if="isCreateUser"
      style="padding: 0 10px"
      justify="space-between"
    >
      <van-col span="7">
        <van-button
          style="width: 100%; font-size: 16px; border-radius: 4px"
          color="#3b82c4"
          size="small"
          type="primary"
          @click="onEditOrCopy(event.roomyotei_id, true)"
        >
          編集
        </van-button>
      </van-col>
      <van-col span="7">
        <van-button
          style="width: 100%; font-size: 16px; border-radius: 4px"
          color="#3b82c4"
          size="small"
          type="primary"
          @click="onEditOrCopy(event.roomyotei_id, false)"
        >
          コピー
        </van-button>
      </van-col>
      <van-col span="7">
        <van-button
          style="width: 100%; font-size: 16px; border-radius: 4px"
          size="small"
          type="danger"
          @click="onDelete(event)"
        >
          削除
        </van-button>
      </van-col>
    </van-row>
    <van-row
        v-if="isCreateUser"
        style="padding: 0 10px"
        justify="space-between"
    >
      <van-col span="24" style="display: flex; justify-content: center;">
        <van-button
            v-show="!showShareLink"
            style="width: 150px; font-size: 16px; border-radius: 4px;margin-top:10px;"
            color="#3b82c4"
            size="small"
            type="primary"
            @click="showShareLink = true"
        >招待</van-button>
      </van-col>
    </van-row>

  </van-dialog>
</template>
<script setup>
import Schedule from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import moment from "moment";

import { onMounted, computed, ref, reactive, nextTick, watch } from "vue";
import { GetYoteiDetail, YoteiDelete, GetRoomDetail } from "@/services/room";
import { useRouter, useRoute } from "vue-router";
import { Dialog, Toast } from "vant";

const props = defineProps({
  events: {
    type: Array,
    required: true,
    default: () => [],
  },
  isRoom: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  isNeedEnterRoom: {
    type: Boolean,
    required: false,
    default: () => true,
  },
  action: {
    type: Object,
    required: false,
  },
  schedules: {
    type: Object,
    required: true,
  },
});

const router = useRouter();
const { query } = useRoute();
const isSelectMonth = ref(false);
const currentDate = ref(
  query?.currentDate ? moment(query?.currentDate).toDate() : moment().toDate()
);
const minDate = ref(moment("2023-01-01").toDate());
const maxDate = ref(moment().add(12, "months").toDate());
const scheduleRef = ref(null);
const gridType = ref(query?.gridType);
const isEventDialog = ref(false);
const isEnterRoomLoading = ref(false);
const event = ref(null);
const showShareLink = ref(false);

const userInfo = computed(() => {
  return JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY)) || {};
});

const isCreateUser = computed(() => {
  return event.value?.created_by === userInfo.value?.login_account_id;
});

const isEnterRoom = computed(() => {
  return (
    moment().isBetween(
      moment(event.value.start_time).subtract(5, "minute"),
      moment(event.value.end_time)
    ) && moment().isBefore(moment(event.value.end_time))
  );
});

const scheduleSetup = reactive({
  slotLabelFormat: {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  },
  plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin],
  initialView: query?.gridType || "timeGridWeek",
  locale: "ja",
  firstDay: 1,
  slotMinTime: "00:00:00",
  slotMaxTime: "23:59:59",
  slotDuration: "00:15:00", //左边时间间隔
  allDayText: "終日",
  buttonText: {
    today: "今日",
    day: "日",
    week: "週",
    month: "月",
    list: "今日のタスク一覧",
  },
  headerToolbar: {
    left: "dayGridMonth timeGridWeek timeGridDay",
    center: "title",
    right: "listDay prev,next",
  },
  views: {
    //周视图
    timeGridWeek: {
      slotLabelFormat: {
        hour: "numeric",
        minute: "2-digit",
        hour12: false,
      },
      titleFormat: function (date) {
        const startMonth = date.start.month + 1;
        const endMonth = date.end.month + 1;

        if (startMonth === endMonth) {
          return startMonth + "月";
        } else {
          return startMonth + "月～" + endMonth + "月";
        }
      },
      dayHeaderFormat: function (date) {
        const day = date.date.day;
        const weekNum = date.date.marker.getDay();
        const week = ["(日)", "(月)", "(火)", "(水)", "(木)", "(金)", "(土)"][
          weekNum
        ];

        return day + " " + week;
      },
    },
    timeGrid: {
      allDaySlot: false,
    },
  },
  height: 670,
  validRange: () => ({
    start: "2023-01-01",
    end: moment().add(12, "months").format("YYYY-MM-DD"),
  }),
  events: [],
  datesSet: async (info) => initStyle(info),
  eventClick: async (info) => {
    if (info?.event?.id) {
      event.value = props.schedules.find(
        (e) => e.roomyotei_id === info?.event?.id
      );
      showShareLink.value = false;
      isEventDialog.value = true;
    }
  },
  dateClick: (info) => {
    gridType.value = info?.view?.type;
    if (!info?.date || info?.date < new Date()) {
      Toast.fail("開始時刻は過去の時間を選択できません。");
      return;
    }
    goToScheduleEditPage({
      yoteiStartTime: moment(info?.date).format("YYYY-MM-DD HH:mm"),
    });
  },
  eventDrop: () => {},
  eventResize: () => {},
  displayEventTime: false,
});

const onGotoMonth = (queryCurrent) => {
  try {
    scheduleRef.value
      ?.getApi()
      ?.gotoDate(
        queryCurrent
          ? moment(queryCurrent).format("YYYY-MM-DD")
          : moment(currentDate.value).format("YYYY-MM-DD")
      );
    isSelectMonth.value = false;
  } catch (error) {
    console.error(error);
  }
};

const initStyle = async (info) => {
  try {
    if (info?.view?.type) gridType.value = info?.view?.type;
    await nextTick();
    if (info?.view?.currentStart) currentDate.value = info?.view?.currentStart;
    const tableTbody = document.getElementsByTagName("tbody");
    if (tableTbody && tableTbody.length) {
      tableTbody[0].style.background = "white";
    }

    const allHeaderWeek = document.getElementsByClassName(
      "fc-col-header-cell-cushion"
    );
    if (allHeaderWeek.length) {
      for (const week of allHeaderWeek) {
        week.style.width =
          info?.view?.type !== "timeGridWeek" && info?.view?.type
            ? "100%"
            : "2.45rem";
      }
    }

    const els = document.getElementsByClassName("fc-event");
    if (els.length) {
      for (const el of els) {
        const eventTitle = el.getElementsByClassName(
          "fc-event-title-container"
        );
        if (eventTitle && eventTitle.length) {
          Object.assign(eventTitle[0].style, {
            color: "rgb(112,103,90)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          });
        }
        if (
          (!info?.view?.type &&
            gridType?.value === "dayGridMonth" &&
            query.gridType === "dayGridMonth") ||
          info?.view?.type === "dayGridMonth"
        ) {
          el.style.borderLeft = "0px";
          continue;
        }
        el.style.borderLeft =
          el.style["background-color"] === "rgb(199, 228, 252)"
            ? "5px solid rgb(33,150,243)"
            : "5px solid rgb(255,152,0)";
        el.style.borderRadius = "0px";
      }
    }
    // 通过获取节点改变样式
    const calendarTitleNode =
      document.getElementsByClassName("fc-toolbar-title");
    if (calendarTitleNode) {
      const calendarTitleNodeParent = calendarTitleNode[0].parentElement;

      Object.assign(calendarTitleNodeParent.style, {
        position: "absolute",
        top: props.isRoom ? "5px" : "1rem",
        left: "50%",
        transform: "translateX(-50%)",
        color: "#0000008F",
        width: "100%",
        display: "flex",
        justifyContent: "center",
      });
    }
    // 获取所有的button 改变button背景色
    const buttons = document.getElementsByClassName("fc-button");
    if (buttons.length) {
      for (const button of buttons) {
        let borderRadius = "7px";
        if (Array.from(button.classList)?.includes("fc-prev-button")) {
          borderRadius = "7px 0 0 7px";
        }
        if (Array.from(button.classList)?.includes("fc-next-button")) {
          borderRadius = "0 7px 7px 0 ";
        }
        Object.assign(button.style, {
          backgroundColor: "#3B82C4",
          // fc-prev-button fc-next-button 这两个按钮需要单独处理
          borderRadius,
          border: "none",
          fontWeight: 600,
        });
      }
    }
    //改变第一行的背景色
    const tableHeader = document.getElementsByTagName("thead");

    if (tableHeader) {
      tableHeader[0].style.background = "rgb(209,218,228)";
    }
    //改变当前天的背景
    const htmlElement = document.documentElement;
    htmlElement.style.setProperty("--fc-today-bg-color", "#E6FDFF");

    // 给月份按钮添加单独的点击事件
    const monthButton = document.getElementsByClassName(
      "fc-dayGridMonth-button"
    );
    if (monthButton) {
      monthButton[0].addEventListener("click", () => {
        isSelectMonth.value = true;
      });
    }
    // 给今日一览按钮添加单独的点击事件
    const listDayButton = document.getElementsByClassName("fc-listDay-button");
    if (listDayButton) {
      listDayButton[0].addEventListener("click", () => {
        onGotoMonth(moment());
      });
    }
  } catch (error) {
    console.error(error);
  }
};

const onEditOrCopy = (id, isEdit) => {
  try {
    goToScheduleEditPage(
      isEdit ? { roomyoteiId: id } : { copyRoomyoteiId: id }
    );
  } catch (error) {
    console.error(error);
  }
};

const goToScheduleEditPage = (query) => {
  const otherParams = props?.action?.getOtherParams() ?? {};
  router.push({
    path: "/roomReservation",
    query: {
      gridType: gridType.value,
      currentDate: currentDate.value,
      ...query,
      ...otherParams,
    },
  });
};

const onDelete = async (event) => {
  const { id, roomyotei_id } = event;
  try {
    await Dialog.confirm({
      title: "",
      message: "削除しますか",
    });
    const {
      data: { code },
    } = await YoteiDelete({ ids: [id] });
    if (code >= 0) {
      scheduleSetup.events = scheduleSetup.events.filter(
        (v) => v.id !== roomyotei_id
      );
      Toast("削除しました。");
    } else {
      Toast("削除できませんでした。");
    }
    isEventDialog.value = false;
  } catch (error) {
    console.error(error);
  }
};

const onEnterRoom = async (id) => {
  isEnterRoomLoading.value = true;
  try {
    const {
      data: {
        data: { detail: roomDetail },
      },
    } = await GetRoomDetail(id);

    if (
      (roomDetail && roomDetail.all_doctor === "1") ||
      roomDetail.join_doctor_ids.includes(userInfo.login_account_id)
    ) {
      router.push({
        path: "/beforeRoom",
        query: { id: roomDetail.id, room_id: roomDetail.room_id },
      });
    } else {
      Toast.fail("アクセス権限がありません。");
    }
  } catch (error) {
    console.error(error);
  } finally {
    isEnterRoomLoading.value = false;
  }
};

const copyText = (value)=>{
  var tempInput = document.createElement("input");
  tempInput.value = value;
  document.body.appendChild(tempInput);
  tempInput.select();
  tempInput.setSelectionRange(0, 99999);
  document.execCommand("copy");
  document.body.removeChild(tempInput);
  Toast('コピーしました');
};

watch(
  () => props.events,
  async (events) => {
    try {
      scheduleSetup.events = events;
      scheduleSetup.datesSet();
    } catch (error) {
      console.error(error);
    }
  },
  {
    immediate: true,
    deep: true,
  }
);
onMounted(async () => {
  try {
    if (query.currentDate) {
      onGotoMonth(query?.currentDate);
    }
  } catch (error) {
    console.error(error);
  }
});
</script>

<style></style>
